<template>
  <div>
    <input
      ref="price"
      type="tel"
      v-capusta-money="currency"
      :data-focus="dataFocus"
      :class="{ 'invalid': $v.$error }"
      :id="inputId"
      :title="inputTitle"
      :placeholder="placeholder"
      :value="value"
      :readonly="readonly"
      @change="inputHandler"
    />

    <label
      :for="inputId"
      v-text="title"
    ></label>

    <slot />
  </div>
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators';
import { isLessMaxAmount, isMoreMinAmount } from './CustomValidators';

import { formatAmount } from 'lib/utils/amount';

export default {
  name: 'InputPrice',
  props: {
    value: [Number, String],
    required: Boolean,
    inputTitle: String,
    inputId: String,
    dataFocus: Boolean,
    inputPlaceholder: {
      type: String,
      default() {
        return '0.00 ₽';
      },
    },
    minValue: {
      type: Number,
      default() {
        return 1000;
      },
    },
    maxValue: {
      type: Number,
      default() {
        return 999999999999999;
      },
    },
    readonly: {
      type: Boolean,
      default() {
        return false;
      },
    },
    commission: {
      type: Number,
      default() {
        return 0;
      },
    },
    currency: {
      type: Object,
      required: true,
    },
  },
  validations() {
    return {
      value: {
        required: requiredIf(() => this.required),
        minValue: isMoreMinAmount(this.minValue, this.currency),
        maxValue: isLessMaxAmount(this.maxValue, this.commission, this.currency),
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        const value = val.replace(/\s/g, '');

        if (!isNaN(value) && val) {
          this.$v.$touch();
        }
      },
    },
  },
  computed: {
    title() {
      if (isNaN((this.value || '').deleteSpaces())) {
        return this.inputTitle;
      }

      if (!this.minValue && !this.maxValue) {
        return this.inputTitle;
      }

      if (!this.$v.value.minValue) {
        const minAmount = formatAmount(this.minValue, this.currency);

        return `${this.$t('min.sum')} - ${minAmount}`;
      }

      if (!this.$v.value.maxValue) {
        const maxAmount = formatAmount(this.maxValue, this.currency);

        return `${this.$t('max.sum')} - ${maxAmount}`;
      }

      return this.inputTitle;
    },
    placeholder() {
      return formatAmount(0, this.currency);
    },
  },
  methods: {
    inputHandler(e) {
      this.$emit('change', e.target.value.trim());
      this.$v.$touch();
    },
  },
};
</script>
